import script from "./IndexModelTable.vue?vue&type=script&lang=ts"
export * from "./IndexModelTable.vue?vue&type=script&lang=ts"

import "./IndexModelTable.vue?vue&type=style&index=0&id=ac055424&scoped=true&lang=css"
script.__scopeId = "data-v-ac055424"

export default script